module.exports = __webpack_public_path__ + "static/media/2.2040ed8b.jpeg";